import lottie from 'lottie-web';
import { useEffect, useRef } from 'react';
import LottieAnimations from '@Assets/lottie/Lili_Logo_Loading_Animation.json';

export const SplashScreen = () => {
  const elLottieContainer = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (elLottieContainer.current) {
      lottie.loadAnimation({
        container: elLottieContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: LottieAnimations,
      });
    }
    return () => lottie.destroy();
  }, [elLottieContainer]);
  return (
    <div
      className='flex items-center justify-center w-full h-full bg-surface-primary-bw-00'
      id='main-loader'>
      <div className='w-[128px]' ref={elLottieContainer}></div>
    </div>
  );
};
